import React from 'react';
import { BarChart3, BookOpen, ExternalLink, Search } from 'lucide-react';

const learningAppUrl =
  (import.meta.env.VITE_LEARNING_APP_URL as string | undefined)?.trim() || 'https://arabicroots.de/app/learn';

const StudentLearningAppPage: React.FC = () => {
  const openLearningApp = () => {
    window.location.href = learningAppUrl;
  };

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-neutral-900 rounded-[24px] border border-gray-200 dark:border-neutral-800 shadow-[0_4px_20px_rgba(0,0,0,0.04)] overflow-hidden">
        <div className="p-6 sm:p-8">
          <div className="flex items-start justify-between gap-4 mb-6">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#970000]/10 dark:bg-red-500/15 text-[#970000] dark:text-red-400 text-xs font-bold uppercase tracking-[0.14em] mb-4">
                <span>Beta</span>
              </div>

              <h1 className="text-3xl font-bold text-gray-900 dark:text-neutral-100 mb-3">
                Arabicroots Lernapp
              </h1>

              <p className="text-gray-500 dark:text-neutral-400 max-w-2xl leading-relaxed">
                Lerne Vokabeln, nutze das Wörterbuch und wiederhole Inhalte aus deinen Kursen.
              </p>
            </div>

            <div className="hidden sm:flex w-14 h-14 rounded-2xl bg-[#970000] items-center justify-center shrink-0">
              <BookOpen className="h-7 w-7 text-white" />
            </div>
          </div>

          <div className="grid sm:grid-cols-3 gap-3 mb-7">
            <div className="rounded-2xl border border-gray-100 dark:border-neutral-800 bg-gray-50 dark:bg-neutral-800 p-4">
              <BookOpen className="h-5 w-5 text-[#970000] dark:text-red-400 mb-3" />
              <p className="font-semibold text-gray-900 dark:text-neutral-100 text-sm mb-1">Vokabeln lernen</p>
              <p className="text-xs text-gray-500 dark:text-neutral-400">Wiederhole Wörter aus deinen Kursen.</p>
            </div>

            <div className="rounded-2xl border border-gray-100 dark:border-neutral-800 bg-gray-50 dark:bg-neutral-800 p-4">
              <Search className="h-5 w-5 text-[#970000] dark:text-red-400 mb-3" />
              <p className="font-semibold text-gray-900 dark:text-neutral-100 text-sm mb-1">Wörterbuch</p>
              <p className="text-xs text-gray-500 dark:text-neutral-400">Suche arabische und deutsche Begriffe.</p>
            </div>

            <div className="rounded-2xl border border-gray-100 dark:border-neutral-800 bg-gray-50 dark:bg-neutral-800 p-4">
              <BarChart3 className="h-5 w-5 text-[#970000] dark:text-red-400 mb-3" />
              <p className="font-semibold text-gray-900 dark:text-neutral-100 text-sm mb-1">Fortschritt</p>
              <p className="text-xs text-gray-500 dark:text-neutral-400">Behalte deine Statistik im Blick.</p>
            </div>
          </div>

          <button
            onClick={openLearningApp}
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-2xl bg-[#970000] text-white text-sm font-semibold hover:bg-[#7a0000] transition-colors shadow-sm"
          >
            Lernapp öffnen
            <ExternalLink className="h-4 w-4" />
          </button>

          <p className="text-xs text-gray-400 dark:text-neutral-500 mt-4">
            Du wirst mit deinem bestehenden Arabicroots-Zugang weitergeleitet.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StudentLearningAppPage;
